import {PageComponentButtonClass, PageComponentButtonInterface} from "./PageComponentButtonInterface";
import {HighlightedBlockComponentTypeEnum} from "../../Enums/HighlightedBlockComponentTypeEnum";
import {InlineModuleInterface} from "./InlineModuleInterface";
import {HighlightedBlockComponentImageFit} from "../../../../../AdminApp/Views/PageModule/Enums/HighlightedBlockComponentImageFit";

export interface HighlightedBlockComponentInterface {
	title: string,
	title_color: string,
	type: HighlightedBlockComponentTypeEnum,
	background?: string,
	section_background_color?: string,
	lead?: string,
	button: PageComponentButtonInterface,
	collapse?: boolean,
	modules?: InlineModuleInterface,
	imageFit: string;
}

export class HighlightedBlockComponentClass implements HighlightedBlockComponentInterface {
	title = '';
	title_color = '';
	type = HighlightedBlockComponentTypeEnum.LEFT_IMAGE;
	section_background_color = '';
	background = '';
	lead = '';
	button = new PageComponentButtonClass();
	imageFit = HighlightedBlockComponentImageFit.COVER;
}
